const cleanText = (txt) => txt?.replace(/<\/?[^>]+(>|$)/g, '')?.trim() || '';

export default cleanText;
